import React, { forwardRef } from 'react';
import Link from 'next/link';
import { FaCheck } from 'react-icons/fa';
import { SuccessMessage } from '../styles';

type FormSuccessMessageProps = {
  successMessage?: string | null;
  isEn: boolean;
};

const defaultMessage = (isEn: boolean) =>
  isEn
    ? 'Your answers have been submitted. Thanks for your feedback!'
    : 'Suas respostas foram enviadas. Obrigado pelo seu feedback!';

export const FormSuccessMessage = forwardRef<HTMLDivElement, FormSuccessMessageProps>(
  ({ successMessage, isEn }, ref) => {
    const message = successMessage || defaultMessage(isEn);
    return (
      <SuccessMessage ref={ref}>
        <span className="success-icon">
          <FaCheck />
        </span>
        <div>
          <p style={{ whiteSpace: 'pre-line' }}>{message}</p>
          <Link href={isEn ? '/en' : '/pt'} passHref>
            <button>{isEn ? 'Go to homepage' : 'Ir para página inicial'}</button>
          </Link>
        </div>
      </SuccessMessage>
    );
  },
);

FormSuccessMessage.displayName = 'FormSuccessMessage';
